import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: { label: string; to: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div
      className={`mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "md:flex-col md:items-center md:text-center" : ""
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-primary-600">
            <span className="inline-block h-px w-6 bg-primary-400" aria-hidden="true"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex shrink-0 items-center gap-2 rounded-md border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
        >
          {action.label}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}